import { getData } from "./base-api";
import ApiUris from "./apiUris";

export const dashboardApi = {
  getSummary(companyId) {
    return getData(`${ApiUris.dashboardApi.getSummary}?companyId=${companyId}`);
  },
};
